package horcrux.frontend.common.configs

import horcrux.common.Environment
import horcrux.common.RenderingLocation
import horcrux.common.utils.AppLogger
import horcrux.frontend.common.isBrowserEnvironment
import io.ktor.client.plugins.logging.LogLevel
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive

object ApplicationConfigs: AppLogger {
    private val ENVIRONMENT_VARIABLES: JsonObject = if (isBrowserEnvironment()) {
        // In browser env we define HORCRUX_ENV to be the environment variables in base64 format. We use atob to decode.
        Json.decodeFromString<JsonObject>(js("atob(HORCRUX_ENV)").toString())
    } else {
        // If node just define empty map. This is okay since the environment variables will be read in on page load.
        Json.parseToJsonElement("{}").jsonObject
    }.let{
        logger.debug("ENVIRONMENT_VARIABLES: $it")
        it
    }

    val ENVIRONMENT: Environment
        get() = Environment(getEnvironmentVariable(Environment.ENVIRONMENT_VARIABLE_NAME))
    val LOG_LEVEL: LogLevel = when (ENVIRONMENT) {
        Environment.PROD -> LogLevel.NONE
        else -> LogLevel.HEADERS
    }
    val RENDERING_LOCATION: RenderingLocation
        get() = RenderingLocation(getEnvironmentVariable(RenderingLocation.ENVIRONMENT_VARIABLE_NAME))
    const val SIDE_PANEL_NAME: String = "The Grok App"
    val BACKEND_URL: String = getEnvironmentVariableOrElse("BACKEND_URL", "http://localhost:9090")
    val FRONTEND_URL: String = getEnvironmentVariableOrElse("FRONTEND_URL", "http://localhost:8080")


    fun getEnvironmentVariable(name: String): String? {
        return ENVIRONMENT_VARIABLES[name]?.jsonPrimitive?.content
    }

    private fun getEnvironmentVariableOrElse(name: String, default: String): String = getEnvironmentVariable(name) ?: default
}
